import React from "react";
import { useState } from "react";
import  Register  from "../../components/Authantication/Register";
import  Login  from "../../components/Authantication/Login";
import "../../styles/AuthStyles/LoginAndReg.css";
import SideBanner from '../../components/Authantication/SideBanner';

const LoginAndReg = () => {

    const [isLogin, setIsLogin] = useState(true);

    return (
        <div className="loginAndRegContainer">
           <Login
                onSwitch={() => setIsLogin(false)}
                // highlight the login section when isLogin is true
                className={isLogin ? "mobile-active" : ""}
            />

            <Register
                onSwitch={() => setIsLogin(true)}
                // highlight the register section when isLogin is false
                className={!isLogin ? "mobile-active" : ""}
            />
            <SideBanner isLogin={isLogin} onSwitch={() => setIsLogin(!isLogin)} />
        </div>
        
    );
};

export default LoginAndReg;